import { ServerError } from '@/lib/error/ServerError';
import { UnauthenticatedError } from '@/lib/error/UnauthenticatedError';

export const validateResponse = async (response: Response) => {
  if (response.status === 401) {
    throw new UnauthenticatedError();
  }

  if (!response.ok) {
    const data = await response.json();

    throw new ServerError(data);
  }
};
